(() => {
	const FILTERS_SELECTOR = "[data-bv-videos-filters]"
	const PILL_SELECTOR = "[data-bv-videos-theme]"
	const CARD_SELECTOR = "[data-bv-video-card]"
	const SCOPE_SELECTOR = "[data-bv-videos-scope]"
	const EMPTY_SELECTOR = "[data-bv-videos-empty]"
	const INTERACTIVE_ATTR = "data-bv-videos-interactive"
	const BOUND_ATTR = "data-bv-videos-bound"
	const READY_ATTR = "data-bv-videos-ready"

	let activeTheme = ""

	let all = selector => [...document.querySelectorAll(selector)]

	let themeOf = (el, attribute) => el.getAttribute(attribute) || ""

	let syncCards = () => {
		all(CARD_SELECTOR).forEach(card => {
			let theme = themeOf(card, "data-bv-video-theme")
			card.hidden = activeTheme !== "" && theme !== activeTheme
		})

		all(SCOPE_SELECTOR).forEach(scope => {
			let message = scope.querySelector(EMPTY_SELECTOR)
			if (!message) return

			let cards = [...scope.querySelectorAll(CARD_SELECTOR)]
			message.hidden = cards.length === 0 || cards.some(card => !card.hidden)
		})
	}

	let syncPills = () => {
		all(PILL_SELECTOR).forEach(pill => {
			let theme = themeOf(pill, "data-bv-videos-theme")
			pill.setAttribute("aria-pressed", theme === activeTheme ? "true" : "false")
		})
	}

	let select = theme => {
		activeTheme = theme
		syncPills()
		syncCards()
	}

	let scan = () => {
		all(PILL_SELECTOR).forEach(pill => {
			if (pill.hasAttribute(BOUND_ATTR)) return

			pill.setAttribute(BOUND_ATTR, "")
			pill.addEventListener("click", () => select(themeOf(pill, "data-bv-videos-theme")))
		})

		all(FILTERS_SELECTOR).forEach(section => section.setAttribute(INTERACTIVE_ATTR, ""))

		syncPills()
		syncCards()
	}

	if (!document.documentElement.hasAttribute(READY_ATTR)) {
		document.documentElement.setAttribute(READY_ATTR, "")
		scan()
		document.addEventListener("shopify:section:load", scan)
	}
})()
